<template>
    <div id="review-order">
        <el-popover
            placement="top"
            width="380"
            v-model="visible">
            <p style="margin-bottom:20px">請選擇日期</p>
            <el-date-picker
                size="small"
                v-model="timeValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="margin-bottom:20px;">
            </el-date-picker>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="importOut">确定</el-button>
            </div>
            <!-- <el-button slot="reference">删除</el-button> -->
            <div class="export-box" slot="reference">
                <span class="export">导出</span>
            </div>
        </el-popover>
        
        <ekk-fliter 
            placeholder="用户名/手机号"
            :noExport="true"
            :noDate="true"
            :keyword="keyword"
            :statusList="filters.statusList"
            :status="status"
            @status="filters.status"
            :noStatus2="false"
            :status2="shop_id"
            :statusList2="filters.statusList2"
            @status2="filters.status2"
            :noStatus3="false"
            :status3="video_check"
            :statusList3="filters.videoCheckList"
            @status3="filters.videoCheck"
            @keyword="filters.search"
        />
        <div style="margin: 10px 0; text-align: right;">
            <el-button size="small" @click="resetFilters">重置筛选</el-button>
        </div>
        <ekk-table 
            :tableData="viewData.tableData"
            :options="viewData.options"
            :page="viewData.page"
            :feedback="viewData.feedback"
            @handle="viewData.handle"
            @handlePage="viewData.handlePage"
        />
        <transition name="slide-fade">
            <ekk-detail
                v-show="detail.show"
                :show="detail.show"
                :loading="detail.loading"
                :detailData="detail.detailData"
                @close="detail.close"
                @handleVideo="handleVideo"
                @handlePic="handleDetailPic"
            />
        </transition>
        <el-dialog 
        :title="dialogData.fromData.hasOwnProperty('products') && (dialogData.fromData.videoIndex > -1 || showPicMode) ? '' : `发起${dialogData.fromData.hasOwnProperty('products') ? '扣' : '退'}款`" 
        :visible.sync="dialogData.dialogVisible"
        :class="dialogData.fromData.videoIndex > -1 || showPicMode ? 'video-dialog' : 'normal-dialog'"
        >
            <div class="order-dialog">
                <div class="order-dialog-left">
                    <iframe v-if="!showPicMode && dialogData.fromData.videoIndex > -1" 
                            :src="dialogData.fromData.videoList[dialogData.fromData.videoIndex].url" 
                            frameborder="0">
                    </iframe>
                    
                    <div v-if="showPicMode" class="pic-container">
                        <div v-if="picUrls.length === 0" class="no-pics">
                            <i class="el-icon-picture-outline"></i>
                            <p>暫無圖片</p>
                        </div>
                        <div v-else class="pic-content">
                            <div class="pic-grid">
                                <div v-for="(pic, index) in picUrls" :key="index" 
                                     class="pic-item" 
                                     @click="showFullImage(index)">
                                    <img :src="pic" class="grid-img" />
                                </div>
                                <template v-if="picUrls.length < 4">
                                    <div v-for="i in (4 - picUrls.length)" :key="`empty-${i}`" 
                                         class="pic-item empty">
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-dialog-right">
                    <el-form
                    :model="dialogData.fromData"
                    :rules="dialogData.fromRules"
                    ref="fromData"
                    label-width="100px"
                    size="small"
                    class="order-form">
                        <div v-if="dialogData.fromData.row && isOrderMode" class="order-info-section">
                            <div class="order-info-layout">
                                <div class="order-info-left">
                                    <div class="order-info-item">
                                        <span class="info-label">进店时间</span>
                                        <span>{{ dialogData.fromData.row.entered_at || '-' }}</span>
                                    </div>
                                    <div class="order-info-item">
                                        <span class="info-label">离店时间</span>
                                        <span>{{ dialogData.fromData.row.leaved_at || '-' }}</span>
                                    </div>
                                    <div class="order-info-item">
                                        <span class="info-label">离店次数</span>
                                        <span>{{ dialogData.fromData.row.count || 0 }}</span>
                                    </div>
                                </div>
                                <div class="order-info-right">
                                    <div class="order-info-item">
                                        <span class="info-label">总订单</span>
                                        <span>{{ dialogData.fromData.row.total_orders || 0 }}</span>
                                    </div>
                                    <div class="order-info-item">
                                        <span class="info-label">标签</span>
                                        <div>
                                            <el-tag v-for="tag in (dialogData.fromData.row.tags || [])" :key="tag"
                                                v-show="tag.length > 0" size="mini" style="margin-right:4px;">{{ tag }}</el-tag>
                                            <span v-if="!dialogData.fromData.row.tags || dialogData.fromData.row.tags.every(t => t === '')">-</span>
                                        </div>
                                    </div>
                                    <div class="order-info-item" v-if="dialogData.fromData.row.description">
                                        <span class="info-label">备注</span>
                                        <el-tag type="warning" size="mini" style="white-space: normal; height: auto; line-height: 1.4;">{{ dialogData.fromData.row.description }}</el-tag>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-form-item label="内容選擇" v-if="(dialogData.fromData.videoList && dialogData.fromData.videoList.length > 0) || hasPictures">
                            <div class="content-select-wrap">
                                <el-radio-group v-model="selectedContent" @change="handleContentChange" class="radio-group-wrap">
                                    <div class="radio-row" v-if="hasNonStoreSettlementVideos">
                                        <el-radio-button v-for="(item, i) in (dialogData.fromData.videoList || []).filter((v, idx) => v.name !== '店铺结算1')" :key="'video-'+i" size='small' :label="'video-'+getVideoIndex(item, dialogData.fromData.videoList || [])">{{item.name}}</el-radio-button>
                                    </div>
                                    
                                    <div class="radio-row">
                                        <template v-if="hasStoreSettlementVideo">
                                            <el-radio-button v-for="(item, i) in (dialogData.fromData.videoList || []).filter(v => v.name === '店铺结算1')" :key="'store-video-'+i" size='small' :label="'video-'+getVideoIndex(item, dialogData.fromData.videoList || [])">{{item.name}}</el-radio-button>
                                        </template>
                                        <el-radio-button v-if="hasPictures" size='small' :class="{'sole-button': !hasStoreSettlementVideo}" label="pic">结算图片</el-radio-button>
                                    </div>
                                </el-radio-group>
                            </div>
                        </el-form-item>
                        <template v-if="isOrderMode">
                          <el-form-item label="扣款商品" prop="products"  v-if="dialogData.fromData.hasOwnProperty('products') ">
                              <el-autocomplete
                                  v-model="searchGoodsKey"
                                  :fetch-suggestions="querySearchAsync"
                                  placeholder="请搜索商品"
                                  @select="handleSelect"
                                  ></el-autocomplete>
                          </el-form-item>
                          <div v-if="dialogData.fromData.hasOwnProperty('products')" class="product-table-container">
                              <el-table v-show="selectGoods.length > 0" :data="selectGoods" style="width: 100%" size='mini' max-height="250">
                                  <el-table-column prop="product_name" label="商品名称" width="200" :show-overflow-tooltip="true"></el-table-column>
                                  <el-table-column prop="retail_price" label="单价" width="70" :show-overflow-tooltip="true">
                                      <template slot-scope="scope">
                                          <span>{{scope.row.shops[0].retail_price | getPrice}}</span>
                                      </template>
                                  </el-table-column>
                                  <el-table-column prop="retail_price" label="原价" width="70" :show-overflow-tooltip="true">
                                      <template slot-scope="scope">
                                          <span>{{scope.row.shops[0].OriginalPrice | getPrice}}</span>
                                      </template>
                                  </el-table-column>
                                  <el-table-column prop="count" label="数量" width="100">
                                      <template slot-scope="scope">
                                          <el-input-number size="mini" v-model="scope.row.count" :readOnly='true' controls-position="right" @change="handleChange" :min="1" :max="100" style="width: 80px"></el-input-number>
                                      </template>
                                  </el-table-column>
                                  <el-table-column prop="retail_price" label="操作" width="45" align="center">
                                      <template slot-scope="scope">
                                          <el-button type="text" size="mini" @click="handleCancelGoods(scope.row.ID)"><i class="el-icon-close"></i></el-button>
                                      </template>
                                  </el-table-column>
                              </el-table>
                          </div>
                          <el-form-item label="原价" prop="original_total_price" v-if="dialogData.fromData.hasOwnProperty('products')">
                            <span>{{ dialogData.fromData.original_total_price }}元</span>
                            <span style="margin-left: 20px; color: #666;">商品数量：{{ getTotalProductCount() }}件</span>
                          </el-form-item>
                          <el-form-item :label="`${dialogData.fromData.hasOwnProperty('products') ? '扣' : '退'}款金额`" prop="amount">
                              <el-input v-model="dialogData.fromData.amount" placeholder="请输入金额" style="width:200px;margin-right:10px"></el-input>
                              <span>元</span>
                          </el-form-item>
                         
                          <el-form-item label="当前活动" v-if="promotion.promotion_name && dialogData.fromData.hasOwnProperty('products')">
                            <span>{{ promotion.promotion_name }} 折扣{{ promotion.discount }}%</span>
                          </el-form-item>
                        </template>
                        
                        <div class="form-footer">
                            <div class="order-dialog-right-btn" v-if="!isOrderMode">
                                <el-button size="small" style="width: 120px; color: #409EFF; border: 1px solid #409EFF;" @click="dialogData.dialogVisible = false">关 闭</el-button>
                            </div>
                            <div class="order-dialog-right-btn" v-else>
                                <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
                            </div>
                            <div class="order-nav-btn" v-if="isOrderMode">
                                <el-button size="small" icon="el-icon-arrow-left" @click="goPrevOrder">上一个</el-button>
                                <el-button size="small" @click="goNextOrder">下一个<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            
            <div slot="footer" class="dialog-footer" style="display:none;">
                <el-button size="small" @click="dialogData.dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog 
            :visible.sync="fullImageVisible" 
            :append-to-body="true"
            custom-class="full-image-dialog" 
            :show-close="true">
            <div class="full-image-container">
                <img :src="fullImageUrl" class="full-img" />
                <div class="full-image-controls">
                    <el-button @click="prevFullImage" icon="el-icon-arrow-left" circle></el-button>
                    <span>{{ fullImageIndex + 1 }}/{{ picUrls.length }}</span>
                    <el-button @click="nextFullImage" icon="el-icon-arrow-right" circle></el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="detailMediaVisible"
            :append-to-body="true"
            width="1300px"
            :show-close="true"
        >
            <div class="order-dialog">
                <div class="order-dialog-left">
                    <iframe v-if="!detailShowPicMode && detailVideoIndex > -1" 
                            :src="detailVideoList[detailVideoIndex].url" 
                            frameborder="0">
                    </iframe>
                    
                    <div v-if="detailShowPicMode" class="pic-container">
                        <div v-if="detailPicUrls.length === 0" class="no-pics">
                            <i class="el-icon-picture-outline"></i>
                            <p>暫無圖片</p>
                        </div>
                        <div v-else class="pic-content">
                            <div class="pic-grid">
                                <div v-for="(pic, index) in detailPicUrls" :key="index" 
                                     class="pic-item" 
                                     @click="showDetailFullImage(index)">
                                    <img :src="pic" class="grid-img" />
                                </div>
                                <template v-if="detailPicUrls.length < 4">
                                    <div v-for="i in (4 - detailPicUrls.length)" :key="`empty-${i}`" 
                                         class="pic-item empty">
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-dialog-right">
                    <el-form label-width="100px" size="small">
                        <el-form-item label="内容選擇" v-if="detailVideoList.length > 0 || detailPicUrls.length > 0">
                            <el-radio-group v-model="detailSelectedContent" @change="handleDetailContentChange">
                                <el-radio-button v-for="(item, i) in detailVideoList" :key="'video-'+i" size='small' :label="'video-'+i">{{item.name}}</el-radio-button>
                                <el-radio-button v-if="detailPicUrls.length > 0" size='small' label="pic">結算圖片</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-dialog>
        <el-dialog 
            :visible.sync="detailFullImageVisible" 
            :append-to-body="true"
            custom-class="full-image-dialog" 
            :show-close="true">
            <div class="full-image-container">
                <img :src="detailFullImageUrl" class="full-img" />
                <div class="full-image-controls">
                    <el-button @click="prevDetailFullImage" icon="el-icon-arrow-left" circle></el-button>
                    <span>{{ detailFullImageIndex + 1 }}/{{ detailPicUrls.length }}</span>
                    <el-button @click="nextDetailFullImage" icon="el-icon-arrow-right" circle></el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import util from "@/utils/util";
import ekkTable from '@/components/ekk_table.vue'
import ekkFliter from '@/components/ekk_fliter.vue'
import ekkDetail from '@/components/ekk_detail.vue'

import { mapState,mapActions } from 'vuex';
import { ORDER_SHOP_ID, ORDER_STATUS } from '@/store/types';

export default {
    name:'review-order',
    components: { 
        ekkTable,
        ekkFliter,
        ekkDetail 
    },
    data(){
        return {
            shop_id:'',
            status:'',
            keyword:'',
            video_check:'',
            // 緩存相關
            cacheKey: 'review_order_filters_cache',
            filters:{
                statusList: [
                    {id: '', name: '全部状态'},
                    {id: '0', name: '待处理'},
                    {id: 'unauthorized', name: '未授权'},
                    {id: '1', name: '支付成功'},
                    {id: '2', name: '支付失败'},
                    {id: '3', name: '订单取消'},
                    {id: '4', name: '订单过期'},
                    {id: '5', name: '支付中'},
                    {id: '6', name: '退款成功'},
                    {id: '7', name: '退款失败'},
                ],
                videoCheckList: [
                    {id: '', name: '全部'},
                    {id: '2', name: '图片扣款'},
                    {id: '1', name: '视频扣款'},
                    {id: '0', name: '待判断'},
                ],
                status: val => {
                    [this.status,this.viewData.page.cur] = [val, 1];
                    this[ORDER_STATUS](this.status);
                    this.saveFiltersToCache();
                    this.getList()
                },
                statusList2: [
                    {id: '', name: '全部门店'},
                    // {id: 'W0001', name: 'W0001'},
                    // {id: 'W0002', name: 'W0002'},
                    // {id: 'W0003', name: 'W0003'},
                ],
                status2: val => {
                    [this.shop_id,this.viewData.page.cur] = [val, 1];
                    this[ORDER_SHOP_ID](this.shop_id);
                    this.saveFiltersToCache();
                    this.getList()
                },
                videoCheck: val => {
                    [this.video_check,this.viewData.page.cur] = [val, 1];
                    this.saveFiltersToCache();
                    this.getList()
                },
                // 关键字筛选
                search: val => {
                    setTimeout( ()=>{
                        [this.keyword,this.viewData.page.cur] = [val, 1];
                        this.saveFiltersToCache();
                        this.getList();
                    },300)
                },
            },
            viewData: {
                options: [
                    {prop: "entered_at",label: '进店时间',width: 120,overflow: true,},
                    {prop: "leaved_at",label: '离店时间',width: 140,overflow: true,},
                    {prop: "count",label: '离店',width: 40,overflow: true,},
                    {prop: "is_face",label: '刷脸',width: 40,overflow: true,},
                    {prop: "shop_name",label: '门店',width: 80,overflow: true,},
                    {prop: "out_order_no",label: '订单号',width: 130,overflow: true,},
                    {prop: "total",label: '订单金额',width: 70,overflow: true,},
                    {prop: "total_orders",label: '总订单',width: 60,overflow: true,center:true},
                    {prop: "need_video_check_display",label: '扣款类型',width: 70,overflow: true,center:true},
                    {prop: "nickName",label: '微信昵称',width: 100,overflow: true,},
                    {prop: "phone",label: '手机号',width: 100,overflow: true,},
                    {prop: "tags",label: '标签',width: 100},
                    {prop: "pay_status",label: '状态',width: 60,overflow: true,},
                    {label: '操作', width: 120,center: true,slot: [
                        { type: "order", condition: 'pay_status', conditionList:{
                            '待处理':'扣款',
                        }},
                        { type: "close", condition: 'pay_status', conditionList:{
                            '待处理':'关闭',
                        }},
                        // { type: "refund", condition: 'can_refund', conditionList:{
                        //     'Y':'退款',
                        // }},
                        // { type:'video', condition: 'has_video_url',conditionList:{
                        //     'Y':'结算1',
                        // }},
                        // { type:'video2', condition: 'has_video_url2',conditionList:{
                        //     'Y':'结算2',
                        // }},
                        // { type:'video3', condition: 'has_video_url3',conditionList:{
                        //     'Y':'店内',
                        // }},
                        { type: "detail", name:'详情',},
                    ],},
                ],
                tableData: [],
                page: { cur: 1, size: 20, total: 0, },
                feedback: "",
                // 列表操作
                handle: (row, type) => {
                    this.dialogData.fromData = {
                        "openid":row.user.openid,
                        "out_order_no":row.out_order_no,
                        "amount":"",
                    };
                    switch (type) {
                        case "detail":
                            this.handleDetail(row);
                            break;
                        case "order":
                            this.handleOrder(row);
                            break;
                        case "close":
                            this.handleClose();
                            break;
                        case 'refund':
                            this.handleOrder(row, 'refund');
                            break;
                        case "video":
                            window.open(row.video_url);
                            break;
                        case "video2":
                            window.open(row.video_url2);
                            break;
                        case "video3":
                            window.open(row.video_url3);
                            break;
                        default:
                            break;
                    }
                },
                // 页码切换
                handlePage: (val) => {
                    this.viewData.page.cur = val;
                    this.getList();
                },
            },
            detail: {
                show: false,
                loading: false,
                detailData: {
                    title: '复核订单-详情',
                    top:{
                        img:'',
                        title:''
                    },
                    infos: [
                        {title: '用户信息', info: [
                            {name: '微信昵称', val: ''},
                            {name: '手机号', val: ''},
                            {name: '备注', val: ''},
                            {name: '进店时间', val: ''},
                            {name: '离店时间', val: ''},
                        ]},
                        {title: '订单信息', info: [
                            {name: '门店', val: ''},
                            {name: '离店次数', val: ''},
                            {name: '是否刷脸', val: ''},
                            {name: '订单号', val: ''},
                            {name: '订单金额', val: ''},
                            {name: '订单状态', val: ''},
                        ]},
                    ]
                },
                // 关闭详情
                close: () => {
                    this.detail.show = false
                }
            },
            dialogData:{
                dialogVisible:false,
                fromData:{
                    "openid":"",
                    "out_order_no":"",
                    "amount":"",
                    picIndex: '',
                    currentPicIndex: 0,
                },
                fromRules: {
                    amount: [
                        { required: true, message: '请输入金额', trigger: 'blur' },
                    ],
                },
            },
            loading:false,
            searchGoodsKey:'',
            goodsList:[],
            promotion: {
              promotion_name: '',
              discount: 0,
            },
            selectGoods:[],
            visible:false,
            timeValue:'',
            tempPicUrls: [],
            tempPicIndex: 0,
            showPicMode: false,
            lastVideoIndex: -1,
            picUrls: [],
            selectedContent: 'video-0',
            fullImageVisible: false,
            fullImageIndex: 0,
            detailMediaVisible: false,
            detailVideoIndex: -1,
            detailVideoList: [],
            detailShowPicMode: false,
            detailPicUrls: [],
            detailSelectedContent: '',
            detailFullImageVisible: false,
            detailFullImageIndex: 0,
            isOrderMode: true,
            currentOrderIndex: -1,
            currentlyDetailedRow: null,
        }
    },
    computed: {
        ...mapState({
            order_shop_id: state => state.order.shop_id,
            order_status: state => state.order.status
        }),
        hasPictures() {
            if (!this.dialogData.fromData.last_pic_record) return false;
            const record = this.dialogData.fromData.last_pic_record;
            return !!(record.pic_url1 || record.pic_url2 || record.pic_url3 || record.pic_url4);
        },
        currentPicUrl() {
            return this.picUrls[this.dialogData.fromData.currentPicIndex] || '';
        },
        actualPicUrl() {
            return this.currentPicUrl;
        },
        currentPicDisplay() {
            return this.dialogData.fromData.currentPicIndex + 1 + '/' + this.picUrls.length;
        },
        fullImageUrl() {
            return this.picUrls[this.fullImageIndex] || '';
        },
        detailFullImageUrl() {
            return this.detailPicUrls[this.detailFullImageIndex] || '';
        },
        hasStoreSettlementVideo() {
            return this.dialogData.fromData.videoList && this.dialogData.fromData.videoList.some(v => v.name === '店铺结算1');
        },
        hasNonStoreSettlementVideos() {
            return this.dialogData.fromData.videoList && this.dialogData.fromData.videoList.some(v => v.name !== '店铺结算1');
        },
    },
    watch:{
        timeValue(val){
            console.log(val)
        },
        selectGoods:{
            handler(val){
                if (this.dialogData.fromData && Array.isArray(this.dialogData.fromData.products)) {
                    this.dialogData.fromData.products = val.map(v=> ({product_id: v.ID, count: v.count, price:v.shops[0].retail_price, original_price: v.shops[0].OriginalPrice}));
                    
                    this.dialogData.fromData.amount = util.getPrice(this.dialogData.fromData.products.reduce((prev, current, currentIndex, arr) => {
                        return prev+(current.price * current.count);
                    }, 0)).replace('¥','');
                    this.dialogData.fromData.original_total_price = util.getPrice(this.dialogData.fromData.products.reduce((prev, current, currentIndex, arr) => {
                        return prev+(current.original_price * current.count);
                    }, 0)).replace('¥','');
                }
            },
            deep:true
        }
    },
    filters:{
        getPrice(val){
            return util.getPrice(val)
        }
    },
    created(){
        // 先加載緩存的篩選條件
        this.loadFiltersFromCache();
        
        // 如果緩存中沒有數據，使用默認值
        if (!this.shop_id) {
            this.shop_id = this.order_shop_id;
        }
        if (!this.status) {
            this.status = this.order_status;
        }
        
        this.getShopList();
        this.getList();
    },
    methods:{
        ...mapActions([ORDER_SHOP_ID, ORDER_STATUS]),
        // 保存篩選條件到緩存
        saveFiltersToCache() {
            const filters = {
                shop_id: this.shop_id,
                status: this.status,
                keyword: this.keyword,
                video_check: this.video_check
            };
            localStorage.setItem(this.cacheKey, JSON.stringify(filters));
        },
        // 從緩存恢復篩選條件
        loadFiltersFromCache() {
            const cached = localStorage.getItem(this.cacheKey);
            if (cached) {
                try {
                    const filters = JSON.parse(cached);
                    this.shop_id = filters.shop_id || '';
                    this.status = filters.status || '';
                    this.keyword = filters.keyword || '';
                    this.video_check = filters.video_check || '';
                } catch (e) {
                    console.error('Failed to parse cached filters:', e);
                }
            }
        },
        // 清除篩選條件緩存
        clearFiltersCache() {
            localStorage.removeItem(this.cacheKey);
        },
        // 重置篩選條件
        resetFilters() {
            this.shop_id = '';
            this.status = '';
            this.keyword = '';
            this.video_check = '';
            this.viewData.page.cur = 1;
            this.clearFiltersCache();
            this.getList();
        },
        // 获取门店列表
        getShopList(){
            this.$http.get('smart_shops',{
                params:{}
            }).then( res =>{
                let _list = res.map(v=> ({id: v.shop_id, name: v.shop_name}))
                this.filters.statusList2.push.apply(this.filters.statusList2, _list)
            }).catch( err =>{
            })
        },
        updateMemo(openid,memo){
            // let _index = this.viewData.tableData.findIndex(v => v.user.openid == openid);
            // this.viewData.tableData[_index].user.memo = memo;
            console.log(this.viewData.tableData)
            const _tableData = this.viewData.tableData.map(v=>{
                if(v.openid == openid){
                    v.user.memo = memo;
                    v.tags = memo.split(',');
                }
                return v;
            })

            console.log(_tableData)

            this.viewData.tableData = _tableData;

        },
        //获取列表
        getList(){
            this.viewData.feedback = 'loading';
            this.viewData.tableData = [];

            this.$http.get('orders',{
                params:{
                    shop_id:this.shop_id,
                    status:this.status,
                    search:this.keyword,
                    need_video_check:this.video_check,
                    review: 1,
                    page:this.viewData.page.cur,
                    pagesize:this.viewData.page.size,
                }
            }).then( res =>{
                let {lists,total} = res;
                let _listCopy = [];
                if(lists.length>0){
                    lists.forEach((item, index) => {
                        _listCopy.push({
                            ...item,
                            'total':item.pay_status == 0 ? '' : util.getPrice(item.total),
                            'total_orders': item.user.order_stats ? item.user.order_stats.total_orders : 0,
                            'nickName':item.user.nickName,
                            'phone':item.user.phone,
                            'tags':item.user.memo.split(','),
                            'pay_status': item.pay_status == 0 && item.need_confirm == 1 ? '未授权' : util.getPayStatus(item.pay_status),
                            'created_at': util.getLocalTime({
                                data:util.getRequestTime(item.created_at) 
                            }),
                            'is_face':item.is_face == 1?"是":"否",
                            'count':item.count,
                            'leaved_at': item.leaved_at !='0001-01-01T00:00:00Z'?util.getLocalTime({
                                data:util.getRequestTime(item.leaved_at) 
                            }):'',
                            'entered_at': item.entered_at !='0001-01-01T00:00:00Z'?util.getLocalTime({
                                data:util.getRequestTime(item.entered_at) 
                            }):'',
                            
                            'shop_name':item.shop.shop_name,
                            'can_refund': util.getPayStatus(item.pay_status) == '支付成功' && !item.refund_order.ID ? 'Y' : 'N',
                            'has_video_url':item.video_url != '' ? 'Y' : 'N',
                            'has_video_url2':item.video_url2 != '' ? 'Y' : 'N',
                            'has_video_url3':item.video_url3 != '' ? 'Y' : 'N',
                            'need_video_check': item.need_video_check,
                            'need_video_check_display': item.need_video_check == 1 ? '视频扣款' : item.need_video_check == 0 ? '待判断' : '图片扣款'
                        });
                    });
                    this.viewData.feedback = '';
                }else{
                    this.viewData.feedback = 'empty';
                }
                this.viewData.tableData = _listCopy;
                this.viewData.page.total = total;
            }).catch( err =>{
                this.viewData.feedback = 'error';
            })
        },
        // 店铺下搜索商品
        handleSearchGoods(){
            // /search_shop_products/{shop_id}
        },
        remoteMethod(query) {
            if(query == '') return;
            const _shopId = this.dialogData.fromData.row.shop_id;
            const _out_order_no = this.dislogData.fromData.out_order_no;
            this.$http.get(`search_shop_products/${_shopId}/${_out_order_no}`,{
                params:{
                    shop_id:_shopId,
                    search:query,
                }
            }).then( res =>{
                this.goodsList = res.lists;
                this.promotion = res.promotion;
            }).catch( err =>{
            })
        },
        querySearchAsync(queryString, cb) {
            if(queryString == '') { cb([]); return; }
            const _shopId = this.dialogData.fromData.row.shop_id;
            const _out_order_no = this.dialogData.fromData.row.out_order_no;
            this.$http.get(`search_shop_products/${_shopId}/${_out_order_no}`,{
                params:{
                    shop_id:_shopId,
                    search:queryString,
                }
            }).then( res =>{
                this.goodsList = res.lists.map(v=>({...v,'value':v.product_name}));
                this.promotion = res.promotion;
                cb(this.goodsList)
            }).catch( err =>{
                cb([])
            })
        },
        handleSelect(item) {
            // 檢查是否已經選擇了該商品
            const existingIndex = this.selectGoods.findIndex(goods => goods.ID === item.ID);
            if (existingIndex !== -1) {
                this.$message({
                    type: "warning",
                    duration: 2000,
                    message: '該商品已經在列表中，請勿重複選擇！',
                });
                return;
            }
            
            this.selectGoods.push({
                ...item,
                'count':1
            })
            this.$nextTick(() => {
                this.searchGoodsKey = '';
            });
        },
        handleChange(value) {
            // console.log(111,value);
        },
        handleCancelGoods(produceId){
            let _index = this.selectGoods.findIndex(v => v.ID == produceId);
            this.selectGoods.splice(_index,1)
        },
        findNextPendingOrder(startIndex) {
            const tableData = this.viewData.tableData;
            for (let i = startIndex + 1; i < tableData.length; i++) {
                if (tableData[i].pay_status === '待处理') {
                    return tableData[i];
                }
            }
            return null;
        },
        findPrevPendingOrder(startIndex) {
            const tableData = this.viewData.tableData;
            for (let i = startIndex - 1; i >= 0; i--) {
                if (tableData[i].pay_status === '待处理') {
                    return tableData[i];
                }
            }
            return null;
        },
        goNextOrder() {
            const nextRow = this.findNextPendingOrder(this.currentOrderIndex);
            if (nextRow) {
                this.handleOrder(nextRow);
            } else {
                this.$message({ type: "info", duration: 2000, message: '没有下一个待处理订单' });
            }
        },
        goPrevOrder() {
            const prevRow = this.findPrevPendingOrder(this.currentOrderIndex);
            if (prevRow) {
                this.handleOrder(prevRow);
            } else {
                this.$message({ type: "info", duration: 2000, message: '没有上一个待处理订单' });
            }
        },
        // 发起扣款
        submitForm() {
            this.$refs['fromData'].validate((valid) => {
            if (valid) {
                // /complete_order/:openid/:out_order_no?amount=1
                let { openid,out_order_no,amount, products, original_total_price} = this.dialogData.fromData;
                const _isOrder = this.dialogData.fromData.hasOwnProperty('products');
                if(Number(amount) <= 0){
                    this.$message({
                        type: "error",
                        duration: 2000,
                        message: `${_isOrder ? '扣' : '退'}款金额需大于0！`,
                    });
                    return;
                }
                if( _isOrder && products.length > 0){
                    let _amount = products.reduce((prev, current) => {
                        return prev+(current.price * current.count)
                    }, 0);
                    if(_amount != (amount * 100).toFixed(0)){
                        this.$message({
                            type: "error",
                            duration: 2000,
                            message: '扣款金额不等于所有商品价格，请重新核对',
                        });
                        return;
                    }
                    
                }
                if(_isOrder){
                    this.$http.post(`complete_order_product/${openid}/${out_order_no}`,{
                        amount:Number((amount * 100).toFixed(0)),
                        original_total_price:Number((original_total_price * 100).toFixed(0)),
                        products: products,
                        out_order_no: out_order_no
                    }).then( res =>{
                        this.$message({
                            type: "success",
                            duration: 2000,
                            message: '扣款成功！',
                        });
                        // 本地标记当前订单为已处理
                        if (this.currentOrderIndex >= 0) {
                            this.viewData.tableData[this.currentOrderIndex].pay_status = '支付中';
                        }
                        // 查找下一个待处理订单
                        const nextRow = this.findNextPendingOrder(this.currentOrderIndex);
                        if (nextRow) {
                            this.handleOrder(nextRow);
                        } else {
                            this.$message({ type: "info", duration: 2000, message: '当前页没有更多待处理订单' });
                            this.dialogData.dialogVisible = false;
                            this.getList();
                        }
                    }).catch( err =>{
                        this.$message({
                            type: "error",
                            duration: 2000,
                            message: '扣款失败，请重试！',
                        });
                    })
                }else{
                    this.$http.get(`refund_order/${openid}/${out_order_no}`,{
                        params:{
                            amount:Number((amount * 100).toFixed(0)),
                        }
                    }).then( res =>{
                        this.$message({
                            type: "success",
                            duration: 2000,
                            message: '退款成功！',
                        });
                        this.dialogData.dialogVisible = false;
                        this.getList();
                    }).catch( err =>{
                        this.$message({
                            type: "error",
                            duration: 2000,
                            message: '退款失败，请重试！',
                        });
                    })
                }
                
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            if(this.$refs[formName]){
                this.$refs[formName].resetFields();
            }
        },
        // 关闭订单
        handleClose() {
            let { openid,out_order_no} = this.dialogData.fromData;

			this.$confirm(`确定要关闭订单${out_order_no}吗？`,'提示',{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: "warning",
			}).then(() => {
                
                this.$http.get(`cancel_order/${openid}/${out_order_no}`,{
                    params:{}
                }).then( res =>{
                    this.$message({
                        type: "success",
                        duration: 2000,
                        message: '关单成功！',
                    });
                    this.getList();
                }).catch( err =>{
                    this.$message({
                        type: "error",
                        duration: 2000,
                        message: '关单失败，请重试！',
                    });
                })
                
			}).catch(() => { });
		},
        // 导出 
        importOut() {
            this.visible = false;
            let start_time,end_time;
            if(this.timeValue){
                start_time = this.timeValue[0].getTime()/1000;
                end_time = this.timeValue[1].getTime()/1000 + 60*60*24 - 1;
            }else{
                start_time = '';
                end_time = '';
            }
            let url = this.$http.defaults.baseURL + 
                `orders/export?shop_id=${this.shop_id}&begin=${start_time}&end=${end_time}`;
            window.open(url)
        },
        handleDetail(row){
            this.currentlyDetailedRow = row;
            this.isOrderMode = false;
            let _videoList = [];
            
            if(row.last_video_record && row.last_video_record.video_url) {
                _videoList.push({
                    name:'店铺结算1',
                    url:row.last_video_record.video_url,
                })
            }
            
            if(row.has_video_url == 'Y'){
                _videoList.push({
                    name:'结算1',
                    url:row.video_url,
                })
            }
            if(row.has_video_url2 == 'Y'){
                _videoList.push({
                    name:'结算2',
                    url:row.video_url2,
                })
            }
            if(row.has_video_url3 == 'Y'){
                _videoList.push({
                    name:'店内',
                    url:row.video_url3,
                })
            }

            this.detail.show = true;
            this.dialogData.fromData = {
                "openid":row.user.openid,
                "out_order_no":row.out_order_no,
                "amount":"",
                "last_pic_record": row.last_pic_record,
                "currentPicIndex": 0
            };
            this.detail.detailData = {
                title: '订单管理-详情',
                top:{
                    img:row.avatarUrl,
                    title:row.nickName,
                    openid:row.user.openid
                },
                infos: [
                    {title: '基本信息', info: [
                        {name: '微信昵称', val: row.nickName},
                        {name: '手机号', val: row.phone},
                        {name: '备注', val: row.user.memo.split(',')},
                        {name: '总订单次数', val: row.user.order_stats ? row.user.order_stats.total_orders : 0},
                        {name: '购物订单次数', val: row.user.order_stats ? row.user.order_stats.shopping_orders : 0},
                        {name: '无购物订单次数', val: row.user.order_stats ? row.user.order_stats.no_shopping_orders : 0},
                        {name: '需视频检查', val: row.need_video_check == 1 ? '视频扣款' : row.need_video_check == 0 ? '待判断' : '图片扣款'},
                        {name: '进店时间', val: row.entered_at},
                        {name: '离店时间', val: row.leaved_at},
                        {name: '门店ID', val: row.shop_id},
                        {name: '门店名', val: row.shop?.shop_name},
                        {name: '离店次数', val: row.count},
                        {name: '是否刷脸', val: row.is_face},
                        {name: '店內视频',video:_videoList, last_pic_record: row.last_pic_record}
                    ]},
                    {title: '订单信息', info:
                        row.pay_status == '待处理' ? [
                            {name: '订单号', val: row.out_order_no},
                            {name: '订单状态', val: row.pay_status},
                            ...(row.description ? [{name: '描述', val: row.description}] : []),
                        ]: row.refund_order.ID ? [
                            {name: '订单号', val: row.out_order_no},
                            {name: '订单状态', val: row.pay_status},
                            {name: '订单金额', val: row.total},
                            {name:'支付时间',val:row.payed_at !='0001-01-01T00:00:00Z'?util.getLocalTime({
                                    data:util.getRequestTime(row.payed_at) }):''},
                            {name: '退款时间', val: row.refund_order.payed_at !='0001-01-01T00:00:00Z'?util.getLocalTime({
                                data:util.getRequestTime(row.refund_order.payed_at) }):''} ,
                            {name: '退款金额', val: util.getPrice(row.refund_order.total)} ,
                            ...(row.description ? [{name: '描述', val: row.description}] : []),
                        ]:[
                            {name: '订单号', val: row.out_order_no},
                            {name: '订单状态', val: row.pay_status},
                            {name: '订单金额', val: row.total},
                            {name: '支付时间',val:row.payed_at !='0001-01-01T00:00:00Z'?util.getLocalTime({
                                    data:util.getRequestTime(row.payed_at) }):''},
                            ...(row.description ? [{name: '描述', val: row.description}] : []),
                        ]
                    },
                ],
                table:row.order_products.length > 0 ? {
                    tab:['扣款商品'],
                    tableData:row.order_products.map(v=>({...v,retail_price:util.getPrice(v.retail_price)})),
                    options: [
                        {prop: 'product_name', label: '商品名称', overflow: true, width: 160},
                        {prop: 'retail_price', label: '售价', overflow: true},
                        {prop: 'count', label: '数量', overflow: true},
                    ],
                    feedback: '', 
                }: null,
                btns: (row.pay_status == '待处理' || row.pay_status == '支付中') ? [
                    {btnName:'扣款', btnEvent:()=>{
                        this.handleOrder(row);
                    }},
                    {btnName:'关闭', btnEvent:()=>{
                        this.handleClose();
                    }},
                ] : row.can_refund == 'Y' ? [
                    {btnName:'退款', btnEvent:()=>{
                        this.handleOrder(row, 'refund');
                    }},
                ] : null,
            }
            
        },
        handleOrder(data, mode = 'order') {
            this.loading = false;
            this.searchGoodsKey = '';
            this.goodsList = [];
            this.selectGoods = [];
            this.promotion = { promotion_name: '', discount: 0 };

            let _videoList = [];
            let openid, out_order_no, last_pic_record_data, originalRowData, amount_value;

            if (mode === 'media') {
                this.isOrderMode = false;
                originalRowData = data.originalFullRow; // 包含完整的原始訂單行信息
                _videoList = data.video || []; 
                openid = data.openid;
                out_order_no = data.out_order_no;
                last_pic_record_data = data.last_pic_record;
                amount_value = "";
            } else { // 'order' or 'refund'
                this.isOrderMode = true;
                originalRowData = data; // 此時 data 就是表格的 row
                this.currentOrderIndex = this.viewData.tableData.findIndex(
                    row => row.out_order_no === data.out_order_no
                );
                openid = originalRowData.user.openid;
                out_order_no = originalRowData.out_order_no;
                last_pic_record_data = originalRowData.last_pic_record;

                // 組裝視頻列表
                if(originalRowData.last_video_record && originalRowData.last_video_record.video_url) {
                    _videoList.unshift({
                        name:'店铺结算1',
                        url:originalRowData.last_video_record.video_url,
                    });
                }
                if(originalRowData.has_video_url == 'Y'){
                    _videoList.push({ name:'结算1', url:originalRowData.video_url });
                }
                if(originalRowData.has_video_url2 == 'Y'){
                    _videoList.push({ name:'结算2', url:originalRowData.video_url2 });
                }
                if(originalRowData.has_video_url3 == 'Y'){
                    _videoList.push({ name:'店内', url:originalRowData.video_url3 });
                }
                
                if (mode === 'refund' && originalRowData.total) {
                    amount_value = originalRowData.total.toString().replace('¥','');
                } else {
                    amount_value = "";
                }
            }

            let newFromData = {
                openid: openid,
                out_order_no: out_order_no,
                amount: amount_value,
                videoList: _videoList,
                videoIndex: _videoList.length > 0 ? 0 : -1,
                last_pic_record: last_pic_record_data,
                currentPicIndex: 0,
                row: originalRowData, 
            };

            if (mode === 'order') {
                newFromData.products = []; // 只有 order 模式明確添加 products
            }
            // 對於 refund 和 media 模式，newFromData 將不包含 products 屬性

            this.dialogData.fromData = newFromData; // 賦值全新構建的對象

            this.showPicMode = false; 
            
            // 根據 need_video_check 字段決定默認選擇
            const needVideoCheck = originalRowData.need_video_check;
            
            if (needVideoCheck === 2 && this.hasPictures) {
                // 圖片結算：默認選擇結算圖片
                this.selectedContent = 'pic';
                this.showPicMode = true;
                this.loadPictures();
            } else if (_videoList.length > 0) {
                // 其他情況：優先選擇 "结算1" 視頻
                const settlementVideo = _videoList.find(v => v.name === '结算1');
                if (settlementVideo) {
                    const settlementVideoIndex = this.getVideoIndex(settlementVideo, _videoList);
                    this.selectedContent = 'video-' + settlementVideoIndex;
                    this.dialogData.fromData.videoIndex = settlementVideoIndex;
                } else {
                    // 如果沒有 "结算1"，則選擇第一個視頻
                    this.selectedContent = 'video-' + this.getVideoIndex(_videoList[0], _videoList);
                }
            } else if (this.hasPictures) { // hasPictures 內部會依賴 this.dialogData.fromData.last_pic_record
                this.selectedContent = 'pic';
                this.showPicMode = true;
                this.loadPictures(); 
            } else {
                this.selectedContent = ''; 
                // this.dialogData.fromData.videoIndex = -1; // 已在 newFromData 中初始化
            }
            
            this.dialogData.dialogVisible = true;
            // console.log(`handleOrder mode: ${mode}, fromData:`, JSON.parse(JSON.stringify(this.dialogData.fromData)));
        },
        
        handleDetailPic(picRecord) {
            // 處理點擊圖片的情況
            this.detailVideoList = [];
            this.detailPicUrls = [];
            
            // 收集所有圖片
            if (picRecord) {
                if (picRecord.pic_url1) this.detailPicUrls.push(picRecord.pic_url1);
                if (picRecord.pic_url2) this.detailPicUrls.push(picRecord.pic_url2);
                if (picRecord.pic_url3) this.detailPicUrls.push(picRecord.pic_url3);
                if (picRecord.pic_url4) this.detailPicUrls.push(picRecord.pic_url4);
            }
            
            if (this.detailPicUrls.length > 0) {
                this.detailSelectedContent = 'pic';
                this.detailVideoIndex = -1;
                this.detailShowPicMode = true;
                this.detailMediaVisible = true;
            }
        },
        handleVideo(v_emitted, mode) {
            if (mode === 'media') {
                // 從 ekk-detail 點擊視頻時觸發
                if (this.currentlyDetailedRow) {
                    const constructed_data = {
                        video: v_emitted.video || [], // v_emitted 包含 video 列表和 last_pic_record
                        last_pic_record: v_emitted.last_pic_record,
                        openid: this.currentlyDetailedRow.user.openid,
                        out_order_no: this.currentlyDetailedRow.out_order_no,
                        originalFullRow: this.currentlyDetailedRow // 傳遞完整的原始訂單行數據
                    };
                    this.handleOrder(constructed_data, 'media');
                } else {
                    console.error("無法獲取 currentlyDetailedRow，無法處理視頻點擊");
                }
            } 
        },
        handleDetailContentChange(value) {
            if (value.startsWith('video-')) {
                // 顯示視頻
                this.detailShowPicMode = false;
                this.detailVideoIndex = parseInt(value.substring(6));
            } else if (value === 'pic') {
                // 顯示圖片
                this.detailShowPicMode = true;
                this.detailVideoIndex = -1;
            }
        },
        showDetailFullImage(index) {
            this.detailFullImageIndex = index;
            this.detailFullImageVisible = true;
        },
        prevDetailFullImage() {
            if (this.detailFullImageIndex > 0) {
                this.detailFullImageIndex--;
            } else {
                this.detailFullImageIndex = this.detailPicUrls.length - 1;
            }
        },
        nextDetailFullImage() {
            if (this.detailFullImageIndex < this.detailPicUrls.length - 1) {
                this.detailFullImageIndex++;
            } else {
                this.detailFullImageIndex = 0;
            }
        },
        prevPic() {
            if (this.dialogData.fromData.currentPicIndex > 0) {
                this.dialogData.fromData.currentPicIndex--;
            } else {
                this.dialogData.fromData.currentPicIndex = this.picUrls.length - 1;
            }
        },
        nextPic() {
            if (this.dialogData.fromData.currentPicIndex < this.picUrls.length - 1) {
                this.dialogData.fromData.currentPicIndex++;
            } else {
                this.dialogData.fromData.currentPicIndex = 0;
            }
        },
        handleContentChange(value) {
            console.log("內容選擇變更:", value);
            
            if (value.startsWith('video-')) {
                // 顯示視頻
                this.showPicMode = false;
                this.dialogData.fromData.videoIndex = parseInt(value.substring(6));
            } else if (value === 'pic') {
                // 顯示圖片
                this.showPicMode = true;
                this.dialogData.fromData.videoIndex = -1;
                
                // 載入圖片URLs
                this.loadPictures();
            }
        },
        handlePicClick() {
            // 如果當前在顯示視頻，則保存視頻索引以便可以返回
            if (!this.showPicMode && this.dialogData.fromData.videoIndex >= 0) {
                this.lastVideoIndex = this.dialogData.fromData.videoIndex;
            }
            
            // 切換至圖片模式
            this.showPicMode = true;
            this.dialogData.fromData.videoIndex = -1; // 禁用視頻顯示
            this.dialogData.fromData.currentPicIndex = 0; // 重置圖片索引
        },
        imageLoaded() {
            // 图片加载成功后的处理逻辑
        },
        imageError() {
            // 图片加载失败后的处理逻辑
        },
        // 載入圖片
        loadPictures() {
            if (!this.dialogData.fromData.last_pic_record) return;
            
            const record = this.dialogData.fromData.last_pic_record;
            this.picUrls = [];
            
            if (record.pic_url1) this.picUrls.push(record.pic_url1);
            if (record.pic_url2) this.picUrls.push(record.pic_url2);
            if (record.pic_url3) this.picUrls.push(record.pic_url3);
            if (record.pic_url4) this.picUrls.push(record.pic_url4);
            
            this.dialogData.fromData.currentPicIndex = 0;
            console.log("載入圖片URLs:", this.picUrls);
        },
        showFullImage(index) {
            this.fullImageIndex = index;
            this.fullImageVisible = true;
        },
        prevFullImage() {
            if (this.fullImageIndex > 0) {
                this.fullImageIndex--;
            } else {
                this.fullImageIndex = this.picUrls.length - 1;
            }
        },
        nextFullImage() {
            if (this.fullImageIndex < this.picUrls.length - 1) {
                this.fullImageIndex++;
            } else {
                this.fullImageIndex = 0;
            }
        },
        getVideoIndex(item, videoList) {
            if (!videoList || !videoList.length) return 0;
            return videoList.findIndex(v => v.name === item.name && v.url === item.url);
        },
        // 計算商品總數量
        getTotalProductCount() {
            if (!this.dialogData.fromData.products || !Array.isArray(this.dialogData.fromData.products)) {
                return 0;
            }
            return this.dialogData.fromData.products.reduce((total, product) => {
                return total + (product.count || 0);
            }, 0);
        },
    }
}
</script>

<style lang="scss" scoped>
.video-dialog{
    ::v-deep .el-dialog{
        width: 1400px !important;
        margin-top: 20vh !important;
        .el-dialog__header{
            position: absolute;
            right: 6px;
            top: 6px;
            z-index: 10;
            padding: 0;
            .el-dialog__title { display: none; }
            .el-dialog__headerbtn {
                position: static;
                width: 32px;
                height: 32px;
                background: rgba(0,0,0,0.5);
                border-radius: 50%;
                .el-dialog__close {
                    color: #fff;
                    font-size: 16px;
                    font-weight: bold;
                }
                &:hover {
                    background: rgba(0,0,0,0.7);
                }
            }
        }
        .el-dialog__body{
            padding: 0;
        }
        .el-dialog__footer{
            display: none;
        }
    }
    .order-dialog{
        display: flex;
        height: 650px;
        .order-dialog-left{
            width: 910px;
            height: 650px;
            min-height: 650px;
            display: flex;
            align-items: center;
            justify-content: center;
            iframe, .pic-container{
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                display: block;
            }
        }
        .order-dialog-right{
            padding: 30px 20px 20px 0;
            width: 590px;
            height: 650px;
            min-height: 650px;
            display: flex;
            flex-direction: column;
            
            .order-form {
                flex: 1;
                overflow-y: auto;
            }
        }
    }
}

.normal-dialog{
    ::v-deep .el-dialog{
        width: 1400px !important;
        margin-top: 20vh !important;
        .el-dialog__header{
            position: absolute;
            right: 6px;
            top: 6px;
            z-index: 10;
            padding: 0;
            .el-dialog__title { display: none; }
            .el-dialog__headerbtn {
                position: static;
                width: 32px;
                height: 32px;
                background: rgba(0,0,0,0.5);
                border-radius: 50%;
                .el-dialog__close {
                    color: #fff;
                    font-size: 16px;
                    font-weight: bold;
                }
                &:hover {
                    background: rgba(0,0,0,0.7);
                }
            }
        }
        .el-dialog__body{
            padding: 0 !important;
        }
        .el-dialog__footer{
            display: none !important;
        }
    }
    .order-dialog{
        display: flex;
        height: 650px;
        .order-dialog-left{
            width: 910px;
            height: 650px;
            min-height: 650px;
            display: flex;
            align-items: center;
            justify-content: center;
            iframe, .pic-container{
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                display: block;
            }
        }
        .order-dialog-right{
            padding: 30px 20px 20px 0;
            width: 590px;
        }
    }
}

.pic-container {
    width: 100%;
    height: 100%;
    background-color: #000;
    position: relative;
}

.pic-content {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
}

.pic-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.pic-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;
}

.pic-controls span {
    color: white;
    margin: 0 15px;
    font-size: 14px;
}

.pic-controls .el-button {
    padding: 7px;
    margin: 0 8px;
}

.no-pics {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: white;
    font-size: 18px;
}

.no-pics i {
    font-size: 60px;
    margin-bottom: 20px;
}

.pic-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    background-color: #000;
}

.pic-item {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #222;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        transform: scale(1.02);
        box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
    }
    
    &.empty {
        background-color: #333;
        cursor: default;
    }
}

.grid-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
}

.full-image-dialog {
    width: 80% !important;
    max-width: 1200px;
    
    ::v-deep .el-dialog__body {
        padding: 0;
    }
}

.full-image-container {
    position: relative;
    background-color: #000;
    width: 100%;
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.full-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.full-image-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
}

.full-image-controls span {
    color: white;
    margin: 0 15px;
    font-size: 14px;
}

.radio-group-wrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  
  ::v-deep .el-radio-button {
    margin-bottom: 8px;
    
    &:not(:last-child) {
      margin-right: 0;
    }
  }
}

.radio-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  
  ::v-deep .el-radio-button {
    margin-bottom: 8px;
    margin-right: 0;
    
    .el-radio-button__inner {
      border-radius: 0;
    }
    
    &:first-child .el-radio-button__inner {
      border-radius: 4px 0 0 4px;
    }
    
    &:last-child .el-radio-button__inner {
      border-radius: 0 4px 4px 0;
    }
    
    &:only-child .el-radio-button__inner {
      border-radius: 4px;
    }
    
    &.sole-button .el-radio-button__inner {
      border-radius: 4px;
    }
  }
}

.content-select-wrap {
  width: 100%;
  
  ::v-deep .el-radio-group {
    display: flex;
    flex-direction: column;
  }
}

.form-footer {
    margin-top: 20px;
}

.order-nav-btn {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #ebeef5;
}

.order-dialog-right-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    
    .el-button {
        margin: 0;
        
        & + .el-button {
            margin-left: 15px;
        }
    }
}

.product-table-container {
    margin-left: 0; /* 重置左邊距 */
    margin-bottom: 18px; /* 與表單項間距保持一致 */
    padding-left: 0; /* 確保沒有內邊距 */
    position: relative;
    left: 20px; /* 適度向左偏移，與標題對齊 */
    width: calc(100% - 20px); /* 調整寬度以補償偏移 */
}
.order-info-section {
    margin: 0 10px 12px;
    padding: 10px 14px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}
.order-info-layout {
    display: flex;
    font-size: 13px;
    gap: 24px;
}
.order-info-left, .order-info-right {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.order-info-left {
    flex: 1;
}
.order-info-right {
    flex: 1;
}
.order-info-item {
    display: flex;
    align-items: baseline;
}
.info-label {
    color: #909399;
    min-width: 56px;
    flex-shrink: 0;
}
.info-label::after {
    content: '：';
}
</style>